var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSnow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    enableBackground: "new 0 0 64 64",
    height: "64px",
    id: "Layer_1",
    viewBox: "0 0 64 64",
    width: "64px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "    M42.543,42.908h12.102c4.623,0,8.369-3.346,8.369-7.471c0-3.731-3.062-6.825-7.064-7.382l0,0c0-6.523-5.732-12.564-12.084-12.564    c-0.205,0,0.199-0.01,0,0c-3.363,0.182-6.346,1.846-8.336,4.367",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "    M43.865,15.491C43.107,7.54,36.045,1.31,27.444,1.31c-9.106,0-16.487,6.982-16.487,15.6c0,0.836,0.069,1.656,0.203,2.457l0,0    C5.434,20.04,0.987,25.036,0.987,31.099c0,6.521,5.149,11.81,11.5,11.81h3.791",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 16.22,
    x2: 12.045,
    y1: 61.926,
    y2: 57.752
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 11.281,
    x2: 16.983,
    y1: 60.602,
    y2: 59.076
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 14.896,
    x2: 13.368,
    y1: 56.988,
    y2: 62.691
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 31.886,
    x2: 27.712,
    y1: 60.023,
    y2: 55.85
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 26.949,
    x2: 32.65,
    y1: 58.699,
    y2: 57.172
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 30.564,
    x2: 29.035,
    y1: 55.084,
    y2: 60.787
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 23.145,
    x2: 18.97,
    y1: 51.281,
    y2: 47.107
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 18.207,
    x2: 23.909,
    y1: 49.957,
    y2: 48.43
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 21.822,
    x2: 20.294,
    y1: 46.342,
    y2: 52.047
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 38.814,
    x2: 34.639,
    y1: 49.377,
    y2: 45.203
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 33.875,
    x2: 39.576,
    y1: 48.055,
    y2: 46.527
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 37.488,
    x2: 35.959,
    y1: 44.439,
    y2: 50.143
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 47.9,
    x2: 43.725,
    y1: 58.467,
    y2: 54.291
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 42.961,
    x2: 48.664,
    y1: 57.143,
    y2: 55.615
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 46.576,
    x2: 45.049,
    y1: 53.527,
    y2: 59.229
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnow);
export default __webpack_public_path__ + "static/media/snow.b6f882616b46f07e18c6ca10c56bec58.svg";
export { ForwardRef as ReactComponent };